
import React from 'react';
import AwaitingInput from './AwaitingInput';

const ECatalogue = () => {
  return (
    <AwaitingInput
      title="E-Catalogue Coming Soon"
      message=""
    />
  );
};

export default ECatalogue;
